import React, { useContext, useState, useRef } from 'react';
import { cloneDeep } from 'lodash';

import { DataSource } from '../../../common/grid/DataSource';

import { RestApiContext } from '../../../contexts/RestApiContext';
import { useAggregatedState, useBusyState } from '../../../../helpers';

export const PageContext = React.createContext(null);

const { Provider } = PageContext;
export const PageProvider = ({ ...props }) => {
    const [busy, isBusy, setIsBusy] = useBusyState({});
    const [pageIsReady, setPageIsReady] = useState(false);
    const [state, setState] = useAggregatedState({
        table: null
    });

    const apiClient = useContext(RestApiContext);

    const getLogsTableAsync = async () => {
        try {
            const table = await apiClient.getLogsTableAsync(false, null);
            setState({ table });
        } catch (e) {
            console.debug(e);
            setState({ table: null });
        }
    }

    const loadLogsTableRowsAsync = async (sortAndFilter) => {
        try {
            const table = await apiClient.getLogsTableAsync(true, sortAndFilter);
            return table.data;
        } catch (e) {
            console.debug(e);
        }
    }

    const [gridApi, setGridApi] = useState(null);
    const [gridColumnApi, setGridColumnApi] = useState(null);

    const dataSource = useRef(null);
    const createGridDataSource = ({ table, pageSize, filterModel, onLoadRows }) => {
        dataSource.current = new DataSource();
        dataSource.current.table = cloneDeep(table);
        dataSource.current.pageIndex = 0;
        dataSource.current.pageSize = pageSize;
        dataSource.current.filterModel = filterModel ?? null;
        dataSource.current.onLoadRows = onLoadRows;
    }

    const getGridDataSource = () => {
        return dataSource.current;
    }

    const loadMoreRows = (pageIndex, pageSize) => {
        dataSource.current.reloadRows({ api: gridApi, pageIndex, pageSize });
    }

    return (
        <Provider value={{
            state,
            pageIsReady,
            setPageIsReady,
            isBusy,
            setIsBusy,
            getLogsTableAsync,
            loadLogsTableRowsAsync,
            setGridApi,
            setGridColumnApi,
            createGridDataSource,
            getGridDataSource,
            loadMoreRows
        }}>
            {props.children}
        </Provider>
    );
}